import { render, staticRenderFns } from "./u-text-field-outlined-pill.vue?vue&type=template&id=1a39bcba&scoped=true&"
import script from "./u-text-field-outlined-pill.vue?vue&type=script&lang=js&"
export * from "./u-text-field-outlined-pill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a39bcba",
  null
  
)

export default component.exports